import { $axios } from '@/plugins/axios';

const state = {
  userId: null,

  mode: 'loader', // loader, main, first-check, player, second-check, ... // TODO нужно добавить экран и состояние с ошибкой (error)
  dataLoaded: false, // статус полученных данных
  error: false, // статус ошибки

  staticData: null,
  program: null,
  podcasts: null,
  statuses: null,
  backgroundList: null,

  // id выбранная программа
  currentProgramId: null,

  // путь до текущей озвучки
  currentAudioSrc: null,

  // список пройденных программ
  doneMeditationArray: [],
};

const getters = {
  // id пользователя
  getUserId: (state) => state.userId,

  // список пройденных медитаций
  getDoneMeditationArray: (state) => state.doneMeditationArray,

  // текущее состояние/активный экран приложения
  getMode: (state) => state.mode,

  // получить статические данные по ключу
  getStaticValue: (state) => (value) => state.staticData?.[value],

  // данные Hero
  getHeroData: (state) => ({
    title: state?.staticData?.MAIN_TITLE,
    text: state?.staticData?.MAIN_DESCRIPTION,
    image: { // TODO временно
      local: true,
      src: 'hero-bg.jpg',
    },
    actionStart: {
      name: 'start',
      title: state?.staticData?.BUTTON_START_TEXT,
      text: state?.staticData?.BUTTON_START_TEXT,
      icon: '24/play',
    },
    actionContinue: {
      name: 'continue',
      title: state?.staticData?.BUTTON_CONTINUE_TEXT,
      text: state?.staticData?.BUTTON_CONTINUE_TEXT,
      icon: '24/play',
    },
    actionStartAgain: {
      name: 'start-again',
      title: state?.staticData?.BUTTON_START_AGAIN_TEXT,
      text: state?.staticData?.BUTTON_START_AGAIN_TEXT,
      icon: '24/play',
    },
  }),

  // данные блока About
  getAboutData: (state) => ({
    title: state?.staticData?.MAIN_ABOUT_TITLE,
    text: state?.staticData?.MAIN_ABOUT_DESCRIPTION,
    accordion: {
      title: state?.staticData?.MAIN_ABOUT_TITLE_CONTENT,
      content: state?.staticData?.MAIN_ABOUT_CONTENT,
    },
  }),

  // данные блока Description
  getDescriptionData: (state) => ({
    title: state?.staticData?.MAIN_ABOUT_TITLE,
    content: state?.staticData?.MAIN_ABOUT_CONTENT,
  }),

  // данные программы
  getProgramData: (state, getters) => {
    if (!getters.getDoneMeditationArray
            || !getters.getDoneMeditationArray.length) {
      return {
        ...state.program,
        // если ни одна из медитаций не прослушана, то первая должна быть next: true
        items: (state.program?.items || []).map((item, idx) => {
          if (idx === 0) {
            return {
              ...item,
              next: true,
            };
          }

          return {
            ...item,
          };
        }),
      };
    }

    // установка done для пройденных медитаций
    const doneProgram = (state.program?.items || []).map((item) => {
      if (getters.getDoneMeditationArray.includes(item.id)) {
        return {
          ...item,
          done: true,
          next: false,
        };
      }

      return {
        ...item,
        done: false,
        next: false,
      };
    });

    // установка next для первый найденной медитации !== done, если такая найдена
    const notDoneMeditation = doneProgram.find((item) => !item.done);
    if (notDoneMeditation) {
      notDoneMeditation.next = true;
    }

    return {
      ...state.program,
      items: doneProgram,
    };
  },

  // данные блока Contacts
  getContactsData: (state) => ({
    title: state?.staticData?.CONTACTS_TITLE,
    link: {
      href: state?.staticData?.CONTACTS_VALUE,
      text: state?.staticData?.CONTACTS_VALUE_TEXT,
    },
  }),

  // данные блока VideoBlock
  getPodcastData: (state) => state.podcasts,

  // данные блока HealthCheck
  getStatusesData: (state) => state.statuses,

  // данные фоновых видео
  getBackgroundListData: (state) => state.backgroundList,

  // _________________________

  // id первой медитации
  getFirstProgramId: (state) => state.program?.items?.[0]?.id,

  // id текущей/выбранной медитации
  getCurrentProgramId: (state) => state.currentProgramId,

  // id следующей медитации или первой, если ни одна из них не прослушана
  getNextProgramId: (state, getters) => {
    if (!getters.getProgramData) return null;

    const items = getters.getProgramData?.items || [];

    return items.find((item) => item.next)?.id;
  },

  // данные текущей медитации
  getCurrentProgramData: (state) => {
    if (!state.program || !state.currentProgramId) return null;

    return state.program.items.find((item) => item.id === state.currentProgramId);
  },

  // текущая аудиозапись
  getCurrentAudioSrc: (state) => state.currentAudioSrc,

  // текущая видеозапись
  getCurrentVideo: (state) => {
    if (!state.backgroundList) return null;

    return (state.backgroundList?.items || []).find((item) => item.active)?.video;
  },

  // id первого видео/видео по умолчанию
  getFirstVideoId: (state) => {
    if (!state.backgroundList) return null;

    return state.backgroundList?.items?.[0]?.id;
  },
};

const mutations = {

  // состояние, когда все необходимы данные получены или не получены
  setDataLoaded(state, payload) {
    state.dataLoaded = payload;
  },

  // установка состояния ошибки приложения
  setError(state, payload) {
    state.error = payload;
  },

  // ____________________________________

  // установка id пользователя (берется из localStorage)
  setUserId(state, payload) {
    state.userId = payload;
  },

  setDoneMeditation(state, payload) {
    state.doneMeditationArray = payload;
  },

  // установка активного экрана
  setMode(state, payload) {
    state.mode = payload;
  },

  // сохранение статических данных в state
  setStatic(state, payload) {
    state.staticData = payload;
  },

  // сохранение данных программы (медитаций) в state
  setProgram(state, payload) {
    state.program = payload;
  },

  // сохранение данных подкастов (видео на главной в слайдере) в state
  setPodcasts(state, payload) {
    state.podcasts = payload;
  },

  // сохранение статусов настроения в state
  setStatuses(state, payload) {
    state.statuses = payload;
  },

  // сохранение данных видеофонов в state
  setBackgroundList(state, payload) {
    state.backgroundList = payload;
  },

  // смена активного item
  backgroundListToggleActive(state, payload) {
    if (!state.backgroundList) return;

    state.backgroundList.items = (state.backgroundList.items || []).map((item) => {
      if (item.id === payload) {
        return {
          ...item,
          active: true,
        };
      }

      return {
        ...item,
        active: false,
      };
    });

    localStorage.setItem('NLMK_BACKGROUND_ID', payload);
  },
  // ____________________________________

  // сохранение id текущей медитации в state
  setCurrentProgramId(state, payload) {
    state.currentProgramId = payload;
  },

  // сохранение src текущей аудиодорожки
  setCurrentAudioSrc(state, payload) {
    state.currentAudioSrc = payload;
  },

  // сброс текущей аудиодорожки
  resetAudioSrc(state) {
    state.currentAudioSrc = null;
  },
};

const actions = {
  async fetchData({ commit, dispatch }) {
    commit('setDataLoaded', false);

    try {
      await Promise.all([
        dispatch('fetchStatic'),
        dispatch('fetchProgram'),
        dispatch('fetchPodcasts'),
        dispatch('fetchStatuses'),
        dispatch('fetchBackgroundList'),
      ]);

      commit('setDataLoaded', true);
      commit('setMode', 'body');
    } catch (e) {
      console.error(e);
      commit('setError', true);
    }
  },

  // Статические данные
  async fetchStatic({ commit }) {
    try {
      const result = await $axios.get('/api/static/');
      const { status } = result;
      const data = result?.data?.data;

      if (status === 200 && data) {
        const BACKGROUNDS_BUTTON_TITLE = data.BACKGROUNDS_BUTTON_TITLE || 'Применить';
        const BACKGROUNDS_LIST_DESCRIPTION = data.BACKGROUNDS_LIST_DESCRIPTION || 'Выберите фон';
        const BACKGROUNDS_LIST_TITLE = data.BACKGROUNDS_LIST_TITLE || 'Выбрать фон';
        const BUTTON_CONTINUE_TEXT = data.BUTTON_CONTINUE_TEXT || 'Продолжить';
        const BUTTON_START_TEXT = data.BUTTON_START_TEXT || 'Начать';
        const BUTTON_START_AGAIN_TEXT = data.BUTTON_START_AGAIN_TEXT || 'Начать заново';
        const MAIN_ABOUT_DESCRIPTION = data.MAIN_ABOUT_DESCRIPTION || 'Десять шагов к обретению баланса в мыслях, чувствах, эмоциях и теле.';
        const MAIN_ABOUT_TITLE = data.MAIN_ABOUT_TITLE || 'О программе';
        const MAIN_ABOUT_TITLE_CONTENT = data.MAIN_ABOUT_TITLE_CONTENT || 'Инструкция и рекомендации';
        const MAIN_ABOUT_CONTENT = data.MAIN_ABOUT_CONTENT || '';
        const MAIN_DESCRIPTION = data.MAIN_DESCRIPTION || 'Медитации для ясности ума и эмоциональной стабильности в любых ситуациях';
        const MAIN_TITLE = data.MAIN_TITLE || 'Закалка';
        const MUSIC_LIST_DESCRIPTION = data.MUSIC_LIST_DESCRIPTION || 'Выберите музыку';
        const MUSIC_LIST_TITLE = data.MUSIC_LIST_TITLE || 'Выбор музыки';
        const PODCASTS_LIST_DESCRIPTION = data.PODCASTS_LIST_DESCRIPTION || 'Краткое описание';
        const { PODCASTS_LIST_LINK_HREF } = data;
        const PODCASTS_LIST_LINK_TITLE = data.PODCASTS_LIST_LINK_TITLE || 'Больше видео на YouTube';
        const PODCASTS_LIST_TITLE = data.PODCASTS_LIST_TITLE || 'Видео и подкасты';
        const CONTACTS_TITLE = data.CONTACTS_TITLE || 'Бесплатная консультация психолога';
        const CONTACTS_VALUE_TEXT = data.CONTACTS_VALUE_TEXT || '+7 800 775 04 05';
        const CONTACTS_VALUE = data.CONTACTS_VALUE || '+78007750405';
        const PROGRAMS_LIST_DESCRIPTION = data.PROGRAMS_LIST_DESCRIPTION || 'Выберите программу';
        const PROGRAMS_LIST_TITLE = data.PROGRAMS_LIST_TITLE || 'Программа';
        const SPEAKERS_LIST_DESCRIPTION = data.SPEAKERS_LIST_DESCRIPTION || 'Выберите диктора';
        const SPEAKERS_LIST_TITLE = data.SPEAKERS_LIST_TITLE || 'Выбор диктора';
        const STATISTIC_SET_ERROR_DAY = data.STATISTIC_SET_ERROR_DAY || 'Неправильно указан день. Параметр day может принимать значения 1 || 10';
        const STATISTIC_SET_ERROR_DOUBLE = data.STATISTIC_SET_ERROR_DOUBLE || 'Вы уже заполнили анкету за указанный день';
        const STATISTIC_SET_ERROR_IBLOCK_MODULE = data.STATISTIC_SET_ERROR_IBLOCK_MODULE || 'Module iblock is not installed';
        const STATISTIC_SET_ERROR_SESSION = data.STATISTIC_SET_ERROR_SESSION || 'Не указан код сессии';
        const STATUS_LIST_BUTTON_SKIP_TITLE = data.STATUS_LIST_BUTTON_SKIP_TITLE || 'Пропустить';
        const STATUS_LIST_BUTTON_START_TITLE = data.STATUS_LIST_BUTTON_START_TITLE || 'Начать занятие';
        const STATUS_LIST_BUTTON_DONE_TITLE = data.STATUS_LIST_BUTTON_DONE_TITLE || 'Готово';
        const STATUS_LIST_TITLE = data.STATUS_LIST_TITLE || 'Оцените своё текущее внутреннее состояние';

        const staticData = {
          BACKGROUNDS_BUTTON_TITLE,
          BACKGROUNDS_LIST_DESCRIPTION,
          BACKGROUNDS_LIST_TITLE,
          BUTTON_CONTINUE_TEXT,
          BUTTON_START_TEXT,
          BUTTON_START_AGAIN_TEXT,
          MAIN_ABOUT_DESCRIPTION,
          MAIN_ABOUT_TITLE,
          MAIN_ABOUT_TITLE_CONTENT,
          MAIN_ABOUT_CONTENT,
          MAIN_DESCRIPTION,
          MAIN_TITLE,
          MUSIC_LIST_DESCRIPTION,
          MUSIC_LIST_TITLE,
          PODCASTS_LIST_DESCRIPTION,
          PODCASTS_LIST_LINK_HREF,
          PODCASTS_LIST_LINK_TITLE,
          PODCASTS_LIST_TITLE,
          PROGRAMS_LIST_DESCRIPTION,
          PROGRAMS_LIST_TITLE,
          SPEAKERS_LIST_DESCRIPTION,
          SPEAKERS_LIST_TITLE,
          STATISTIC_SET_ERROR_DAY,
          STATISTIC_SET_ERROR_DOUBLE,
          STATISTIC_SET_ERROR_IBLOCK_MODULE,
          STATISTIC_SET_ERROR_SESSION,
          STATUS_LIST_BUTTON_SKIP_TITLE,
          STATUS_LIST_BUTTON_START_TITLE,
          STATUS_LIST_BUTTON_DONE_TITLE,
          STATUS_LIST_TITLE,
          CONTACTS_TITLE,
          CONTACTS_VALUE_TEXT,
          CONTACTS_VALUE,
        };

        commit('setStatic', staticData);
      }
    } catch (error) {
      throw new Error('Ошибка при получение статических данных');
    }
  },

  // Программы
  async fetchProgram({ commit }) {
    try {
      const result = await $axios.get('/api/program/');
      const { status } = result;
      const data = result?.data?.data;

      if (status === 200 && data) {
        const title = data.TITLE || 'Программа';
        const description = data.DESCRIPTION || 'Выберите программу';
        const items = (data.ITEMS || []).map((item) => {
          const speakers = Object.values((item?.PROPERTIES?.VOICES?.VALUE || {}))
            .map((speaker) => {
              const name = speaker?.PROPERTIES?.SPEAKER?.VALUE?.NAME || '';
              const image = {
                src: speaker?.PROPERTIES?.SPEAKER?.VALUE?.PREVIEW_PICTURE?.SRC,
                alt: name,
              };
              const audio = speaker?.PROPERTIES?.AUDIO?.VALUE?.SRC;
              const id = speaker.ID;
              const code = speaker.CODE;

              return {
                id,
                code,
                name,
                image,
                audio,
              };
            });

          return {
            id: item.ID,
            name: item.NAME,
            time: item.PREVIEW_TEXT,
            speakers,
            disabled: !speakers.length,
          };
        });

        commit('setProgram', { title, description, items });
      }
    } catch (error) {
      throw new Error('Ошибка при получение данных программы');
    }
  },

  // Подкасты
  async fetchPodcasts({ commit }) {
    try {
      const result = await $axios.get('/api/podcasts/');
      const { status } = result;
      const data = result?.data?.data;

      if (status === 200 && data) {
        const title = data.TITLE || 'Видео и подкасты';
        const description = data.DESCRIPTION || 'Видео и подкасты';
        const link = data.LINK;
        const items = (data.ITEMS || []).map((item) => ({
          id: item.ID,
          title: item.NAME || '',
          image: {
            src: item?.PREVIEW_PICTURE?.SRC,
            alt: item?.PREVIEW_PICTURE?.DESCRIPTION || '',
          },
          link: item?.PROPERTIES?.LINK?.VALUE || null,
          video: {
            src: item?.PROPERTIES?.VIDEO?.VALUE?.SRC || null,
            type: item?.PROPERTIES?.VIDEO?.VALUE?.CONTENT_TYPE || null,
          },
        }));

        const podcast = {
          title,
          description,
          link,
          items,
        };

        commit('setPodcasts', podcast);
      }
    } catch (error) {
      throw new Error('Ошибка при получение данных подкастов');
    }
  },

  // Данные проверки настроения
  async fetchStatuses({ commit }) {
    try {
      const result = await $axios.get('/api/statistic/statuses');
      const { status } = result;
      const data = result?.data?.data;

      if (status === 200 && data) {
        const title = data.TITLE || 'Оценка состояния';
        const text = data.DESCRIPTION || 'Оцените своё текущее внутреннее состояние';
        const items = (data.ITEMS || []).map((item) => {
          const id = item.ID;
          const text = item.NAME || '';
          const detailText = item.DETAIL_TEXT || '';
          const previewText = item.PREVIEW_TEXT || '';
          const image = {
            src: item?.PROPERTIES?.ICON?.VALUE?.SRC,
            alt: text,
          };

          return {
            id,
            text,
            detailText,
            previewText,
            image,
          };
        });

        const statuses = { title, text, items };

        commit('setStatuses', statuses);
      }
    } catch (error) {
      throw new Error('Ошибка при получение данных тестирования');
    }
  },

  // Фоновые видео
  async fetchBackgroundList({ commit }) {
    try {
      const result = await $axios.get('/api/background/');
      const { status } = result;
      const data = result?.data?.data;

      const localeStorageID = localStorage.getItem('NLMK_BACKGROUND_ID') || '';

      if (status === 200 && data) {
        const title = data.TITLE || 'Выбор фона';
        const description = data.DESCRIPTION || 'Выберите фоновое видео и звуки';
        const items = (data.ITEMS || []).map((item) => ({
          id: item.ID,
          name: item.NAME || '',
          image: {
            src: item?.PREVIEW_PICTURE?.SRC,
            alt: item?.PREVIEW_PICTURE?.DESCRIPTION || '',
          },
          video: {
            type: item?.PROPERTIES?.FILE?.VALUE?.CONTENT_TYPE || 'video/mp4',
            src: item?.PROPERTIES?.FILE?.VALUE?.SRC,
          },
          previewText: item.PREVIEW_TEXT || '',
          active: localeStorageID === item.ID,
        }));

        const hasActive = items.findIndex((item) => item.active);
        if (hasActive < 0) {
          items[0].active = true;
          localStorage.setItem('NLMK_BACKGROUND_ID', items[0].id);
        }

        const backgroundList = {
          title,
          description,
          items,
        };

        commit('setBackgroundList', backgroundList);
      }
    } catch (error) {
      throw new Error('Ошибка при получение данных фона');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
